export const TakingMedicineSchedule = {
  TakingMedicineScheduleCard: {
    CardTitle: '服薬予定',
  },
};
